import { render, staticRenderFns } from "./errorLayout.vue?vue&type=template&id=97a97b9a&"
import script from "./errorLayout.vue?vue&type=script&lang=js&"
export * from "./errorLayout.vue?vue&type=script&lang=js&"
import style0 from "./errorLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports